<div class="global-search-list-container">
    <ng-container *ngIf="data?.objects.length">
        <ul class="global-search-list-group global-search-list-object">
            <li *ngFor="let object of data?.objects.slice(0,baseCount); let i = index"
                [ngClass]="{'global-search-selected': object.selected}"
                class="global-search-list-item">
                <a (click)="viewResult(object)"
                    (mouseenter)="showDetailTip(object)"
                    [nTooltip]="detailPanel"
                    [ngClass]="{'global-search-list-item-disabled': !object.show}"
                    class="global-search-list-item-link"
                    nTooltipOverlayClass="object-detail-tips"
                    nTooltipPlacement="leftTop"
                    nTooltipTheme="black"
                    nTooltipTrigger="hover">
                    <p class="global-search-list-item-title">
                        <span [innerHTML]="service.getHighLight(object.name, inputValue, '#ffffff')"></span>
                        <span class="global-search-list-item-tag">{{ object.objectDes }}</span>
                    </p>
                    <span *ngIf="object.vstoreName" class="v-store">
                        <svg class="icon">
                            <use xlink:href="#infigo-solid-vStore"></use>
                        </svg>
                        {{ object.vstoreName }}
                    </span>
                </a>
            </li>
            <li *ngIf="data?.objects.length > baseCount"
                class="global-search-list-item">
                <a (click)="viewMore()"
                    class="object-omit">{{i18n.moreButton}}</a>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="data?.operations.length">
        <ul class="global-search-list-group global-search-list-operation">
            <ng-container *ngFor="let operation of data?.operations; let i = index">
                <li *ngIf="operation?.show"
                    [ngClass]="{'global-search-selected': operation.selected}"
                    class="global-search-list-item"
                >
                    <a (click)="viewResult(operation)"
                        class="global-search-list-item-link">
                        <p class="global-search-list-item-title">
                            <span [innerHTML]="service.getHighLight(operation.name, inputValue, '#ffffff')"></span>
                            <span class="global-search-list-item-tag">{{ i18n.operationTag }}</span>
                        </p>
                    </a>
                </li>
            </ng-container>
        </ul>
    </ng-container>

    <ng-container *ngIf="data?.pages.length">
        <ul class="global-search-list-group global-search-list-page">
            <ng-container *ngFor="let page of data?.pages; let i = index">
                <li *ngIf="page?.show"
                    [ngClass]="{'global-search-selected': page.selected}"
                    class="global-search-list-item"
                >
                    <a (click)="viewResult(page)"
                        class="global-search-list-item-link">
                        <p class="global-search-list-item-title">
                            <span [innerHTML]="service.getHighLight(page.name, inputValue, '#ffffff')"></span>
                            <span
                                class="global-search-list-item-tag">{{ i18n.pageTag }}</span>
                        </p>
                    </a>
                </li>
            </ng-container>
        </ul>
    </ng-container>
    <ng-container *ngIf="data?.helps.length">
        <ul class="global-search-list-group global-search-list-page">
            <ng-container *ngFor="let help of data?.helps; let i = index">
                <li [ngClass]="{'global-search-selected': help.selected}"
                    class="global-search-list-item"
                >
                    <a (click)="viewHelp(help)"
                        class="global-search-list-item-link">
                        <p class="global-search-list-item-title">
                            <span [innerHTML]="service.getHighLight(help.name, inputValue, '#ffffff')"></span>
                            <span
                                class="global-search-list-item-tag">{{ i18n.helpTag }}</span>
                        </p>
                          <span class="v-store small-font">
                            {{ help.path }}
                        </span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </ng-container>
    <ng-container
        *ngIf="!(data.objects?.length || data.operations?.length || data.pages?.length ||data?.helps.length) ">
        <ul class="global-search-list-group global-search-list-nodata">
            {{i18n.nodataTipLabel}}
        </ul>
    </ng-container>

    <ng-template #detailPanel>
        <ul *ngIf="detailTips && detailTips.length"
            class="object-detail-panel">
            <ng-container *ngFor="let tip of detailTips">
                <li *ngIf="!((tip.icons && !tip.icons.length) || (!tip.icons && !tip.value))"
                    class="object-detail-panel-item">
                    <span class="object-detail-panel-content">
                        <span class="global-search-list-item-label">{{tip.label}}</span>
                        <span *ngIf="tip.status || tip.status === 0" [ngStyle]="{ 'background-color': strService.statusMap[tip.status].color }"
                            class="global-search-list-item-status"></span>
                        <span *ngIf="tip.value">{{tip.value}}</span>
                        <ng-container *ngIf="tip.icons && tip.icons.length">
                            <ng-container *ngFor="let icon of tip.icons">
                                <button [border]="false" [icon]="icon" nButton></button>
                            </ng-container>
                        </ng-container>
                    </span>
                </li>
            </ng-container>
        </ul>
    </ng-template>
</div>
